export default "__VITE_ASSET__CPRLkud4__"